import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseSepaPredebitNoticeTemplates = [
  {
    id: '-134001',
    language: Language.EN,
    subject: 'Upcoming direct debit for your lease',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_SEPA_PREDEBIT_NOTICE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>This is a reminder that, under the direct debit mandate you set up for the lease at <strong>{{getLeaseMainAddress lease}}</strong>, we will automatically collect the following amount:</p>
        <ul><li>Amount: <strong>{{totalAmount}} €</strong></li>
        <li>Collection date: <strong>{{formatDate invoice.dueDate}}</strong></li>
        <li>Account to be debited: <strong>{{lease.bankAccount.number}}</strong></li>
        </ul>
        <p>No action is required on your part. Please make sure that sufficient funds are available on the account by the collection date.</p>
        {{#if displayOpenBalance}}
        <p></p>
        <p>Your current account balance is <strong>{{accountBalance}} €</strong>.</p>
        {{/if}}
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-134002',
    language: Language.FR,
    subject: 'Prélèvement automatique à venir pour votre bail',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_SEPA_PREDEBIT_NOTICE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Nous vous informons que, dans le cadre du mandat de domiciliation que vous avez mis en place pour le bail sis <strong>{{getLeaseMainAddress lease}}</strong>, nous prélèverons automatiquement le montant suivant :</p>
        <ul><li>Montant : <strong>{{totalAmount}} €</strong></li>
        <li>Date de prélèvement : <strong>{{formatDate invoice.dueDate}}</strong></li>
        <li>Compte à débiter : <strong>{{lease.bankAccount.number}}</strong></li>
        </ul>
        <p>Aucune action n'est requise de votre part. Veuillez vous assurer que des fonds suffisants soient disponibles sur le compte à la date de prélèvement.</p>
        {{#if displayOpenBalance}}
        <p></p>
        <p>Votre solde actuel est de <strong>{{accountBalance}} €</strong>.</p>
        {{/if}}
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
    `,
  },
  {
    id: '-134003',
    language: Language.NL,
    subject: 'Aankomende domiciliëring voor uw huurovereenkomst',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_SEPA_PREDEBIT_NOTICE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Wij herinneren u eraan dat wij, op basis van het domiciliëringsmandaat dat u heeft ingesteld voor de huurovereenkomst op <strong>{{getLeaseMainAddress lease}}</strong>, automatisch het volgende bedrag zullen innen:</p>
        <ul><li>Bedrag: <strong>{{totalAmount}} €</strong></li>
        <li>Inningsdatum: <strong>{{formatDate invoice.dueDate}}</strong></li>
        <li>Te debiteren rekening: <strong>{{lease.bankAccount.number}}</strong></li>
        </ul>
        <p>U hoeft geen actie te ondernemen. Zorg ervoor dat er voldoende saldo op de rekening staat tegen de inningsdatum.</p>
        {{#if displayOpenBalance}}
        <p></p>
        <p>Uw huidige rekeningsaldo is <strong>{{accountBalance}} €</strong>.</p>
        {{/if}}
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-134004',
    language: Language.DE,
    subject: 'Bevorstehende Lastschrift für Ihren Mietvertrag',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_SEPA_PREDEBIT_NOTICE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Wir möchten Sie daran erinnern, dass wir im Rahmen des von Ihnen für den Mietvertrag unter <strong>{{getLeaseMainAddress lease}}</strong> eingerichteten Lastschriftmandats den folgenden Betrag automatisch einziehen werden:</p>
        <ul><li>Betrag: <strong>{{totalAmount}} €</strong></li>
        <li>Einzugsdatum: <strong>{{formatDate invoice.dueDate}}</strong></li>
        <li>Zu belastendes Konto: <strong>{{lease.bankAccount.number}}</strong></li>
        </ul>
        <p>Es ist keine Aktion Ihrerseits erforderlich. Bitte stellen Sie sicher, dass zum Einzugsdatum ausreichende Mittel auf dem Konto verfügbar sind.</p>
        {{#if displayOpenBalance}}
        <p></p>
        <p>Ihr aktueller Kontostand beträgt <strong>{{accountBalance}} €</strong>.</p>
        {{/if}}
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
